// Google Analytics 4 setup

export const initGA = (measurementId, googleAdsId) => {
  if (typeof window !== 'undefined' && measurementId) {
    // Add gtag script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    // Add gtag initialization
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId, {
      page_path: window.location.pathname,
    });

    // Register the Google Ads account too, so conversion events attach correctly
    if (googleAdsId) {
      gtag('config', googleAdsId);
    }
  }
};

export const logPageView = (url, measurementId) => {
  if (typeof window !== 'undefined' && window.gtag && measurementId) {
    window.gtag('config', measurementId, {
      page_path: url,
    });
  }
};

export const logEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
